import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../theme/modern/tokens"

export default makeStyles((theme: ModernTheme) => ({
    overlay: {
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 200,
        background: theme.modern.overlayBg,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: 24,
        overflowY: "auto",
        animation: "$overlaypop .16s ease",

        "@media (max-width:640px)": {
            padding: 12,
        },
    },
    "@keyframes overlaypop": {
        from: {opacity: 0},
        to: {opacity: 1},
    },
    card: {
        /* the card takes focus on opening (index.tsx); a ring in the accent
           shows it when the keyboard put it there, never on a mouse click */
        "&:focus": {
            outline: "none",
        },
        "&:focus-visible": {
            outline: `2px solid ${theme.modern.accent}`,
            outlineOffset: 2,
        },
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 12,
        boxShadow: theme.modern.shadow,
        padding: "16px 18px 14px",
        minWidth: 360,
        maxWidth: 460,
        width: "100%",
        margin: "auto",
        maxHeight: "100%",
        overflowY: "auto",

        "@media (max-width:640px)": {
            minWidth: 0,
        },
    },
    head: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        marginBottom: 12,
    },
    title: {
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".12em",
        textTransform: "uppercase",
        color: theme.modern.accent,
    },
    close: {
        border: "none",
        background: "none",
        color: theme.modern.ink3,
        fontSize: 18,
        lineHeight: 1,
        padding: 4,
        cursor: "pointer",
        borderRadius: 6,

        "&:hover": {color: theme.modern.ink, background: theme.modern.line2},
    },
    body: {
        font: `400 13px/1.5 ${theme.modern.sans}`,
        color: theme.modern.ink,
    },
    actions: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "8px",
        marginTop: 16,
    },
}))
